var _g, _mask, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPcloudy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 442,
    height: 400,
    fill: "none",
    viewBox: "0 0 442 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12_3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 241.472,
    cy: 200,
    r: 200,
    fill: "url(#paint0_linear_12_3)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_12_3",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M280.172 350L131.742 350C58.983 350 0 289.558 0 215C0 140.442 58.983 80 131.742 80C190.248 80 239.846 119.08 257.034 173.156C264.406 171.098 272.164 170 280.172 170C328.678 170 368 210.294 368 260C368 309.706 328.678 350 280.172 350Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_12_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_12_3)",
    fillRule: "evenodd",
    d: "M280.172 350L131.742 350C58.983 350 0 289.558 0 215C0 140.442 58.983 80 131.742 80C190.248 80 239.846 119.08 257.034 173.156C264.406 171.098 272.164 170 280.172 170C328.678 170 368 210.294 368 260C368 309.706 328.678 350 280.172 350Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M131.742 350V349V350ZM280.172 350V351V350ZM257.034 173.156L256.081 173.459L256.373 174.379L257.303 174.119L257.034 173.156ZM131.742 351L280.172 351V349L131.742 349V351ZM-1 215C-1 290.087 58.4078 351 131.742 351V349C59.5582 349 1 289.029 1 215H-1ZM131.742 79C58.4078 79 -1 139.912 -1 215H1C1 140.971 59.5582 81 131.742 81V79ZM257.987 172.853C240.676 118.388 190.71 79 131.742 79V81C189.787 81 239.017 119.773 256.081 173.459L257.987 172.853ZM257.303 174.119C264.588 172.086 272.255 171 280.172 171V169C272.072 169 264.223 170.111 256.765 172.193L257.303 174.119ZM280.172 171C328.103 171 367 210.823 367 260H369C369 209.765 329.253 169 280.172 169V171ZM367 260C367 309.176 328.103 349 280.172 349V351C329.253 351 369 310.235 369 260H367Z",
    mask: "url(#path-2-inside-1_12_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12_3",
    width: 400,
    height: 420,
    x: 41.472,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "overlay",
    result: "effect1_innerShadow_12_3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_12_3",
    width: 368,
    height: 318.647,
    x: 0,
    y: 80,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_12_3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_3",
    x1: 241.472,
    x2: 241.472,
    y1: 0,
    y2: 400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA6C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_3",
    x1: 25.78,
    x2: 374.314,
    y1: 80,
    y2: 341.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcloudy);
export default __webpack_public_path__ + "static/media/pcloudy.bb0c2012828ca335ecb7ba94cf79a9bc.svg";
export { ForwardRef as ReactComponent };